export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/a5251dc31f03-tooliconnumber7.jpg',
  },
  title: "What's the name of the bank or building society the account is, or was, with?",
}
